import React from 'react'

import ErrorIcon from '@material-ui/icons/Error'

export const SyncErrorIcon = props => (
  <ErrorIcon fontSize="small" color="secondary" {...props} />
)

export default SyncErrorIcon
